<template>
  <div class="pageRoot linkListPage collectionModule">
    <div ref="pageCard" class="pageShell">
      <div ref="pageCardMain" class="pageShell__main">
        <div ref="scrollArea" class="pageShell__scroll">
          <div class="listWorkspace">
            <section class="filterCard filterAnchor">
              <div class="linkListFilterPanel">
                <div class="commandDeck">
                  <div class="commandDeck__zone commandDeck__zone--filters">
                    <div class="filterDeckHeader">
                      <div class="filterDeckHeader__leading">
                        <span class="zoneHeader__title">{{ designerName || '设计师资源' }}</span>
                      </div>
                      <div class="actionBar">
                        <el-button class="actionButton actionButtonQuery" type="primary" size="small" icon="el-icon-search" @click="search">查询</el-button>
                        <el-button class="actionButton actionButtonOutline" size="small" icon="el-icon-plus" v-check-role @click="$router.push('/resource/wallpaper/create')">新增壁纸</el-button>
                        <el-button class="actionButton actionButtonGhost" size="small" @click="resetAndSearch">重置</el-button>
                      </div>
                    </div>
                    <div class="filterGrid filterGrid--three">
                      <div class="filterItem">
                        <span class="searchText">资源名称</span>
                        <el-input v-model="name" class="filterControl" size="small" clearable placeholder="请输入资源名称" @keydown.enter.native="search" />
                      </div>
                      <div class="filterItem">
                        <span class="searchText">资源类型</span>
                        <el-select v-model="type" class="filterControl" size="small" clearable placeholder="请选择">
                          <el-option v-for="item in typeOptions" :key="item" :label="item" :value="item" />
                        </el-select>
                      </div>
                      <div class="filterItem">
                        <span class="searchText">资源状态</span>
                        <el-select v-model="status" class="filterControl" size="small" clearable placeholder="请选择">
                          <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value" />
                        </el-select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section ref="tableZone" class="tableCard tableZone">
              <div v-if="!loading && tableData.length" class="tableSection">
                <el-table class="linkTable linkTable--hybrid" :data="tableData" row-key="id" style="width: 100%">
                  <el-table-column label="壁纸名称" prop="wallpaperName" min-width="140" align="center" show-overflow-tooltip />
                  <el-table-column label="缩略图" width="88" align="center">
                    <template slot-scope="scope">
                      <el-image v-if="scope.row.thumbUrl" class="designerAvatar" :src="scope.row.thumbUrl" fit="cover" />
                      <span v-else class="cellEmptyPill">—</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="资源类型" prop="wallpaperType" align="center" />
                  <el-table-column label="设计师类型" prop="designerType" align="center" />
                  <el-table-column label="认证" width="110" align="center">
                    <template slot-scope="scope">{{ scope.row.isAuth === 0 ? '未认证' : '已认证' }}</template>
                  </el-table-column>
                  <el-table-column label="已关联分类" min-width="160" align="center">
                    <template slot-scope="scope">
                      <div v-if="scope.row.categorySimpleVOList && scope.row.categorySimpleVOList.length" class="categoryCell">
                        <router-link v-for="item in scope.row.categorySimpleVOList" :key="item.id" :to="'/collection/classify/info/' + item.id">
                          <el-tag size="mini" effect="plain" class="categoryTag pageTag" :class="'pageTag--tone-' + categoryTagTone(item.id)">{{ item.name }}</el-tag>
                        </router-link>
                      </div>
                      <span v-else class="cellEmptyPill">未关联</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="关联解锁" min-width="160" align="center">
                    <template slot-scope="scope">
                      <el-button type="text" @click="showLock(scope.row.id)">{{ scope.row.defaultLockGroupName || '查看' }}</el-button>
                    </template>
                  </el-table-column>
                  <el-table-column label="状态" width="120" align="center">
                    <template slot-scope="scope">
                      <span class="statusPill" :class="'statusPill--' + wallpaperStatusView(scope.row.onOrOff).pill">
                        <span class="statusPill__dot" aria-hidden="true" />
                        {{ wallpaperStatusView(scope.row.onOrOff).label }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column label="更新时间" prop="updateTime" min-width="160" align="center" />
                  <el-table-column label="操作" width="90" align="center">
                    <template slot-scope="scope">
                      <el-button size="small" class="rowActionBtn rowActionBtn--ghost" @click="openWallpaper(scope.row.id)">查看</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div v-else-if="!loading" class="tableEmpty"><p class="tableEmpty__title">这个设计师还没有资源</p></div>
              <div v-else class="tableSkeletonWrap"><el-skeleton :rows="8" animated /></div>
            </section>
          </div>
        </div>
      </div>
      <div class="pageShell__footer tableCard__footer footerBar">
        <div class="footerSummary">
          共 <strong class="footerSummary__count">{{ listTotalCount }}</strong> 条 · 第 {{ currentPage }} / {{ totalPages }} 页
        </div>
        <el-pagination
          class="linkPagination"
          layout="prev, pager, next, sizes, jumper"
          :total="listTotalCount"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="currentPageSize"
          :current-page.sync="currentPage"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
    <el-dialog title="关联解锁方式" :visible.sync="dialogVisible" width="480px" @close="lockForm = {}">
      <div v-loading="dialogLoading">
        <el-form :model="lockForm" label-position="top" size="small" disabled>
          <el-form-item label="默认解锁方式"><el-input :value="lockForm.defaultUnlockType" /></el-form-item>
          <el-form-item label="数据集解锁方式">
            <div v-for="(item, index) in lockForm.data_unlock_type_list || []" :key="index" class="lockRow">
              <el-input :value="item.lockGroupName" />
              <el-input :value="item.dataSetName" />
            </div>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getWallpaperById } from '../../../api/wallpaperManage'
import { listWallpaperById } from '../../../api/designerManage'
import { mutations } from '../../../utils/store'
import {
  WALLPAPER_STATUS_OPTIONS,
  WALLPAPER_TYPE_OPTIONS,
  categoryTagTone,
  wallpaperStatusView,
} from './designerListHelpers'

export default {
  name: 'DesignerResources',
  data() {
    return {
      name: '',
      type: '',
      status: '',
      tableData: [],
      currentPage: 1,
      currentPageSize: 10,
      total: 0,
      loading: false,
      typeOptions: WALLPAPER_TYPE_OPTIONS,
      statusOptions: WALLPAPER_STATUS_OPTIONS,
      dialogVisible: false,
      dialogLoading: false,
      lockForm: {},
    }
  },
  computed: {
    designerName() {
      return this.$route.query.name || ''
    },
    listTotalCount() {
      const parsed = Number(this.total)
      return Number.isFinite(parsed) ? parsed : 0
    },
    totalPages() {
      if (!this.listTotalCount) return 1
      return Math.max(1, Math.ceil(this.listTotalCount / this.currentPageSize))
    },
  },
  created() {
    if (this.designerName) mutations.setBreadTitle(this.designerName)
    this.getList()
  },
  beforeDestroy() {
    mutations.setBreadTitle(undefined)
  },
  methods: {
    categoryTagTone,
    wallpaperStatusView,
    getList() {
      this.loading = true
      listWallpaperById({
        currentPage: this.currentPage,
        currentPageSize: this.currentPageSize,
        name: this.name,
        type: this.type,
        id: this.$route.params.id,
        status: this.status,
      }).then((res) => {
        if (!res.success) return
        this.total = res.data.total
        this.tableData = res.data.wallpaperVOList || []
      }).finally(() => {
        this.loading = false
      })
    },
    search() {
      this.currentPage = 1
      this.getList()
    },
    resetAndSearch() {
      this.name = ''
      this.type = ''
      this.status = ''
      this.search()
    },
    handleSizeChange(val) {
      this.currentPageSize = val
      this.$nextTick(() => this.getList())
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getList()
    },
    showLock(id) {
      this.dialogVisible = true
      this.dialogLoading = true
      getWallpaperById({ id }).then((res) => {
        if (!res.success) return
        this.lockForm = {
          defaultUnlockType: res.data.defaultLockGroupName,
          data_unlock_type_list: res.data.wallpaperLockGroupVOList || [],
        }
      }).finally(() => {
        this.dialogLoading = false
      })
    },
    openWallpaper(id) {
      const route = this.$router.resolve(`/resource/wallpaper/info/${id}`)
      window.open(route.href, '_blank')
    },
  },
}
</script>

<style scoped>
@import '../../resourceManage/genericResourceManage/linkListTheme.css';
@import '../../resourceManage/genericResourceManage/linkListFilterPanel.css';
@import '../../resourceManage/genericResourceManage/linkActionButtons.css';
@import './designerCategoryTag.css';

.lockRow {
  display: flex;
  gap: 8px;
  margin-bottom: 8px;
}
</style>
